import { Button, Flex, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const NotFound = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Flex justify="center" align="center" className="h-full">
      <Result
        status={404}
        title="404"
        subTitle={t('not_found.title')}
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            {t('button.back_home')}
          </Button>
        }
      />
    </Flex>
  )
}
